import { CheckBox } from '@interstate/components/CheckBox';
import { InformationCircleIcon } from '@interstate/components/Icons/InformationCircleIcon';
import { Tooltip } from '@interstate/components/Tooltip';
import { DAS_OVERRIDES_FIELDS } from '@makemydeal/dr-dash-store/constants';
import * as dueAtSigningActionCreators from '@makemydeal/dr-dash-store/actions/dueAtSigningActionCreators';
import * as dueAtSigningSelectors from '@makemydeal/dr-dash-store/selectors/dueAtSigningSelectors';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import { Box } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { targetCashAmountPaidCheckboxStyle } from '../dealSummary/common/ComponentLabelStyle';
import { dealLockHooks } from '../hooks';

const TargetCashAmountPaidCheckbox = () => {
    const dispatch = useDispatch();
    // Fetch the target cash amount paid flag from the dia overrides selectors
    const targetCashAmountPaidFlag = useSelector(dueAtSigningSelectors.getTargetCashAmountPaidOverride);
    const isDasLocked = useSelector(dueAtSigningSelectors.getIsDasLocked);
    const isOnePayLease = useSelector(offerReduxSelectors.isOnePayLease);
    const isLocked = dealLockHooks.useIsDealLocked();
    const disabled = isOnePayLease || isDasLocked || isLocked;

    return (
        <Box sx={targetCashAmountPaidCheckboxStyle}>
            <CheckBox
                aria-label="Target Cash Amount Paid"
                className="target-cash-amount-paid-checkbox"
                data-testid="target-cash-amount-paid-checkbox"
                id="due-at-signing-checkbox"
                label="Target Cash Amount Paid"
                name="due-at-signing-checkbox"
                value="targetCashAmountPaid"
                checked={targetCashAmountPaidFlag}
                disabled={disabled}
                onChange={(e) => {
                    // Dispatch the action to update the target cash amount paid flag
                    const dueAtSigningDispatch = dueAtSigningActionCreators.updateDasChanges(
                        DAS_OVERRIDES_FIELDS.TARGET_CASH_AMOUNT_PAID
                    );
                    dispatch(dueAtSigningDispatch(e.target.value?.checked));
                }}
            />
            <Tooltip
                position={'right'}
                toolTipContent={'Summary Due At Signing Information'}
                size={'large'}
                data-testid="target-cash-amount-paid-checkbox-tooltip"
            >
                <InformationCircleIcon color="blue" data-testid="target-cash-amount-paid-checkbox-information-circle-icon" />
            </Tooltip>
        </Box>
    );
};

export default TargetCashAmountPaidCheckbox;
